import { render, staticRenderFns } from "./ModalTableSixmark.vue?vue&type=template&id=1e4ace78&"
import script from "./ModalTableSixmark.vue?vue&type=script&lang=js&"
export * from "./ModalTableSixmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports